import { useRoutes } from 'react-router-dom'
import { Provider } from 'react-redux'
import routes from './router'
import store from './store'
import AppHeader from './components/app-header'
import AppFooter from './components/app-footer'
import AppPlayBar from './pages/player/app-play-bar'

const App = () => {
    return (
        <Provider store={store}>
            <AppHeader></AppHeader>
            {useRoutes(routes)}
            <AppFooter></AppFooter>
            <AppPlayBar></AppPlayBar>
        </Provider>
    )
}

export default App
